module.exports = __webpack_public_path__ + "static/media/addAccount.63175c27.svg";